/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Banner_SwitchingInputs */

const en_rmf_banner_switching = /** @type {(inputs: Rmf_Banner_SwitchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`switching world`)
};

const fr_rmf_banner_switching = /** @type {(inputs: Rmf_Banner_SwitchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bascule de world`)
};

const ms_sg2_rmf_banner_switching = /** @type {(inputs: Rmf_Banner_SwitchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`menukar dunia`)
};

/**
* | output |
* | --- |
* | "switching world" |
*
* @param {Rmf_Banner_SwitchingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_banner_switching = /** @type {((inputs?: Rmf_Banner_SwitchingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Banner_SwitchingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_banner_switching(inputs)
	if (locale === "fr") return fr_rmf_banner_switching(inputs)
	return ms_sg2_rmf_banner_switching(inputs)
});